module.exports = __webpack_public_path__ + "static/media/brian_circle.46c0d41e.png";